import React from 'react'
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Grid,
} from '@mui/material'
import { useForm, Controller } from 'react-hook-form'
import { useSnackbar } from 'notistack'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import { extractErrorMessage } from '../../utils/extractErrorMessage'

const validationSchema = yup.object().shape({
  wabaId: yup.string().required('WABA ID is required'),
  phoneNumberId: yup.string().required('Phone Number ID is required'),
  accessToken: yup.string().required('Access Token is required'),
})

const Form = ({ setOpen, open, api, refetch }) => {
  const { control, handleSubmit, reset } = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: { wabaId: '', phoneNumberId: '', accessToken: '' },
  })

  const { enqueueSnackbar } = useSnackbar()
  const { mutateAsync, isLoading } = api()

  const onClose = () => {
    reset()
    setOpen(false)
  }

  const onSubmit = async (values) => {
    try {
      await mutateAsync(values)
      refetch()
      enqueueSnackbar('Successfully created', { variant: 'success' })
      onClose()
    } catch (e) {
      enqueueSnackbar(extractErrorMessage(e), { variant: 'error' })
    }
  }

  return (
    <Dialog maxWidth='sm' open={open} fullWidth>
      <DialogTitle>Create Whatsapp Config</DialogTitle>
      <form onSubmit={handleSubmit(onSubmit)}>
        <DialogContent dividers>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Controller
                name='wabaId'
                control={control}
                render={({ field, fieldState: { error } }) => (
                  <TextField
                    {...field}
                    label='WABA ID'
                    variant='outlined'
                    fullWidth
                    error={!!error}
                    helperText={error?.message}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12}>
              <Controller
                name='phoneNumberId'
                control={control}
                render={({ field, fieldState: { error } }) => (
                  <TextField
                    {...field}
                    label='Phone Number ID'
                    variant='outlined'
                    fullWidth
                    error={!!error}
                    helperText={error?.message}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12}>
              <Controller
                name='accessToken'
                control={control}
                render={({ field, fieldState: { error } }) => (
                  <TextField
                    {...field}
                    label='Access Token'
                    variant='outlined'
                    fullWidth
                    type='password'
                    error={!!error}
                    helperText={error?.message}
                  />
                )}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button variant='outlined' onClick={onClose}>
            CANCEL
          </Button>
          <Button type='submit' variant='contained' color='primary' disabled={isLoading}>
            SUBMIT
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  )
}

export default Form
